var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('status',{attrs:{"is-test-mode":_vm.isTestModeComputed,"view-only":_vm.viewOnlyComputed,"show-banner-tooltip":_vm.showBannerTooltipComputed},on:{"changed":_vm.exportChange}})}
var staticRenderFns = []

export { render, staticRenderFns }